import React, { useState } from 'react';
import { useDidUpdate } from '../../../providers/useDidUpdate';
const HiddenState = ({ children, id }) => (React.createElement("span", { style: { display: 'none' }, id: id }, children));
export const useMSBStates = ({ children, getStateId, selectedStateId, onChange, shouldRenderAllTabs = false, }) => {
    /**
     * We keep state memory to preserve DOM state (like inputs)
     */
    const [pastStateIds, setPastStateIds] = useState([]);
    useDidUpdate(() => {
        onChange?.({ type: 'change' });
        if (!shouldRenderAllTabs && !pastStateIds.includes(selectedStateId)) {
            setPastStateIds([...pastStateIds, selectedStateId]);
        }
    }, [selectedStateId]);
    /**
     * TB Containers pass children as a function
     */
    const stateElements = React.Children.toArray(typeof children === 'function' ? children() : children);
    if (shouldRenderAllTabs) {
        return stateElements;
    }
    const currentOrPastStates = stateElements.filter(state => {
        if (!React.isValidElement(state)) {
            return false;
        }
        const itemId = getStateId(state);
        return selectedStateId === itemId || pastStateIds.includes(itemId);
    });
    if (currentOrPastStates.length) {
        return currentOrPastStates.map(state => selectedStateId === getStateId(state) ? (state) : (
        // If we rendered this state in the past - render it hidden, to maintain DOM state
        React.createElement(HiddenState, { id: state.props.id }, state)));
    }
    return stateElements.slice(0, 1);
};
//# sourceMappingURL=useMSBStates.js.map